import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';

// 导入子页面组件（将在后续创建）
import NftFarmOverview from './NftFarmOverview';
import NftFarmCollections from './NftFarmCollections';
import NftFarmMining from './NftFarmMining';
import NftFarmRewards from './NftFarmRewards';

// NFT矿场容器样式
const NftFarmContainer = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem'
});

/**
 * NFT矿场模块主组件
 * 管理NFT矿场相关路由
 */
const NftFarm: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <NftFarmContainer>
      <Routes>
        <Route path="/" element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<NftFarmOverview />} />
        <Route path="collections" element={<NftFarmCollections />} />
        <Route path="mining" element={<NftFarmMining />} />
        <Route path="rewards" element={<NftFarmRewards />} />
      </Routes>
    </NftFarmContainer>
  );
};

export default NftFarm; 